import sopClassDictionary from '../util/sopClassDictionary';

/**
 * Checks whether dicom files with specified SOP Class UID have image data
 * @param {string} SOPClassUID - SOP Class UID to be checked
 * @returns {boolean} - true if it has image data
 */
export default function isImage(SOPClassUID) {
  return (
    SOPClassUID === sopClassDictionary.ComputedRadiographyImageStorage ||
    SOPClassUID === sopClassDictionary.DigitalXRayImageStorageForPresentation ||
    SOPClassUID === sopClassDictionary.DigitalXRayImageStorageForProcessing ||
    SOPClassUID === sopClassDictionary.DigitalMammographyXRayImageStorageForPresentation ||
    SOPClassUID === sopClassDictionary.DigitalMammographyXRayImageStorageForProcessing ||
    SOPClassUID === sopClassDictionary.DigitalIntraOralXRayImageStorageForPresentation ||
    SOPClassUID === sopClassDictionary.DigitalIntraOralXRayImageStorageForProcessing ||
    SOPClassUID === sopClassDictionary.CTImageStorage ||
    SOPClassUID === sopClassDictionary.EnhancedCTImageStorage ||
    SOPClassUID === sopClassDictionary.LegacyConvertedEnhancedCTImageStorage ||
    SOPClassUID === sopClassDictionary.UltrasoundMultiframeImageStorage ||
    SOPClassUID === sopClassDictionary.MRImageStorage ||
    SOPClassUID === sopClassDictionary.EnhancedMRImageStorage ||
    SOPClassUID === sopClassDictionary.EnhancedMRColorImageStorage ||
    SOPClassUID === sopClassDictionary.LegacyConvertedEnhancedMRImageStorage ||
    SOPClassUID === sopClassDictionary.UltrasoundImageStorage ||
    SOPClassUID === sopClassDictionary.MultiframeSingleBitSecondaryCaptureImageStorage ||
    SOPClassUID === sopClassDictionary.MultiframeGrayscaleByteSecondaryCaptureImageStorage ||
    SOPClassUID === sopClassDictionary.MultiframeGrayscaleWordSecondaryCaptureImageStorage ||
    SOPClassUID === sopClassDictionary.MultiframeTrueColorSecondaryCaptureImageStorage ||
    SOPClassUID === sopClassDictionary.XRayAngiographicImageStorage ||
    SOPClassUID === sopClassDictionary.EnhancedXAImageStorage ||
    SOPClassUID === sopClassDictionary.XRayRadiofluoroscopicImageStorage ||
    SOPClassUID === sopClassDictionary.EnhancedXRFImageStorage ||
    SOPClassUID === sopClassDictionary.XRay3DAngiographicImageStorage ||
    SOPClassUID === sopClassDictionary.XRay3DCraniofacialImageStorage ||
    SOPClassUID === sopClassDictionary.BreastTomosynthesisImageStorage ||
    SOPClassUID === sopClassDictionary.BreastProjectionXRayImageStorageForPresentation ||
    SOPClassUID === sopClassDictionary.BreastProjectionXRayImageStorageForProcessing ||
    SOPClassUID === sopClassDictionary.IntravascularOpticalCoherenceTomographyImageStorageForPresentation ||
    SOPClassUID === sopClassDictionary.IntravascularOpticalCoherenceTomographyImageStorageForProcessing ||
    SOPClassUID === sopClassDictionary.NuclearMedicineImageStorage ||
    SOPClassUID === sopClassDictionary.VLEndoscopicImageStorage ||
    SOPClassUID === sopClassDictionary.VideoEndoscopicImageStorage ||
    SOPClassUID === sopClassDictionary.VLMicroscopicImageStorage ||
    SOPClassUID === sopClassDictionary.VideoMicroscopicImageStorage ||
    SOPClassUID === sopClassDictionary.VLSlideCoordinatesMicroscopicImageStorage ||
    SOPClassUID === sopClassDictionary.VLPhotographicImageStorage ||
    SOPClassUID === sopClassDictionary.VideoPhotographicImageStorage ||
    SOPClassUID === sopClassDictionary.OphthalmicPhotography8BitImageStorage ||
    SOPClassUID === sopClassDictionary.OphthalmicPhotography16BitImageStorage ||
    SOPClassUID === sopClassDictionary.OphthalmicTomographyImageStorage ||
    SOPClassUID === sopClassDictionary.VLWholeSlideMicroscopyImageStorage ||
    SOPClassUID === sopClassDictionary.PositronEmissionTomographyImageStorage ||
    SOPClassUID === sopClassDictionary.EnhancedPETImageStorage ||
    SOPClassUID === sopClassDictionary.LegacyConvertedEnhancedPETImageStorage ||
    SOPClassUID === sopClassDictionary.XRayAngiographicImageStorage ||
    SOPClassUID === sopClassDictionary.RTImageStorage ||
    SOPClassUID === sopClassDictionary.WideFieldOphthalmicPhotographyStereographicProjectionImageStorage ||
    SOPClassUID === sopClassDictionary.SecondaryCaptureImageStorage ||
    SOPClassUID === sopClassDictionary.RetiredUltrasoundImageStorage 
  );
}
